const texts = {
  firstParagraph: `Ao clicar no botão abaixo, todos os estudantes que iniciarem uma solicitação a partir de agora, \ncom os parâmetros \ndefinidos serão aprovados sem sua análise. Isso não é um teste.`,
  secondParagraph: `com os parâmetros definidos serão aprovados sem sua análise. Isso não é um teste.`,

  buttonText: 'Ativar aprovação automática',

  buttonBackText: 'Voltar',
};

export default texts;
